import React from "react";
import FinanceAccountListPage from "./FinanceAccountListPage";

const Receivables = () => (
  <FinanceAccountListPage kind="receivable" title="Contas a Receber" endpoint="/finance/receivables" />
);
export default Receivables;
